class UpsellCheckboxBundle extends HTMLElement {
  constructor() {
    super();
    this.boundOnClick = this.onClick.bind(this);
    this.boundOnChange = this.onChange.bind(this);
    this.boundOnSubmit = this.onSubmit.bind(this);
    this.cards = [];
  }

  connectedCallback() {
    this.mainFormId = this.dataset.mainFormId || "";
    this.mainForm = this.mainFormId ? document.getElementById(this.mainFormId) : null;
    this.cards = Array.from(this.querySelectorAll("[data-upsell-card]")).slice(0, 2);

    if (!this.cards.length || !this.mainForm) return;

    this.setupCards();
this.syncAllCardsUi();

    this.addEventListener("click", this.boundOnClick);
    this.addEventListener("change", this.boundOnChange);
    this.mainForm.addEventListener("submit", this.boundOnSubmit, true);
  }

  disconnectedCallback() {
    this.removeEventListener("click", this.boundOnClick);
    this.removeEventListener("change", this.boundOnChange);

    if (this.mainForm) {
      this.mainForm.removeEventListener("submit", this.boundOnSubmit, true);
    }
  }

  setPriceDisplay(container, currentText, compareText = "") {
    if (!container) return;

    const currentEl = container.querySelector("[data-upsell-price-current]");
    const compareEl = container.querySelector("[data-upsell-price-compare]");

    if (currentEl) {
      currentEl.textContent = currentText || "";
    } else {
      container.textContent = currentText || "";
    }

    if (compareEl) {
      if (compareText) {
        compareEl.textContent = compareText;
        compareEl.hidden = false;
      } else {
        compareEl.textContent = "";
        compareEl.hidden = true;
      }
    }
  }

  setupCards() {
    this.cards.forEach((card) => {
      const state = { selected: ["", "", ""] };
      card.__upsellState = state;

      const singleVariant = card.querySelector("[data-upsell-single-variant]");
      const variantIdInput = card.querySelector("[data-upsell-variant-id]");
      const priceEl = card.querySelector("[data-upsell-price]");
      const map = card.querySelector("[data-upsell-variant-map]");

      const firstAvailableOption = Array.from(map?.options || []).find((option) => {
        return option.value && option.dataset.available === "true";
      });

      if (singleVariant && variantIdInput) {
        variantIdInput.value = singleVariant.value;
        if (map) map.value = singleVariant.value;

        const match = map?.querySelector(`option[value="${CSS.escape(singleVariant.value)}"]`);
        if (priceEl && match) {
          this.setPriceDisplay(
            priceEl,
            match.dataset.price || "",
            match.dataset.comparePrice || ""
          );
        }
      } else if (firstAvailableOption && variantIdInput) {
        variantIdInput.value = firstAvailableOption.value;
        if (map) map.value = firstAvailableOption.value;

        if (priceEl) {
          this.setPriceDisplay(
            priceEl,
            firstAvailableOption.dataset.price || "",
            firstAvailableOption.dataset.comparePrice || ""
          );
        }

        state.selected = [
          firstAvailableOption.dataset.option1 || "",
          firstAvailableOption.dataset.option2 || "",
          firstAvailableOption.dataset.option3 || ""
        ];
      }

      this.updateCardUi(card);
    });
  }

  // ensureAtLeastOneChecked(changedCheckbox = null) {
  //   const checked = this.cards.filter((card) => {
  //     return card.querySelector("[data-upsell-product-checkbox]")?.checked;
  //   });

  //   if (checked.length) return;

  //   if (changedCheckbox) {
  //     changedCheckbox.checked = true;
  //     return;
  //   }

  //   const firstCheckbox = this.cards[0]?.querySelector("[data-upsell-product-checkbox]");
  //   if (firstCheckbox) firstCheckbox.checked = true;
  // }

  isCardSelected(card) {
    return !!card.querySelector("[data-upsell-product-checkbox]")?.checked;
  }

  syncAllCardsUi() {
    this.cards.forEach((card) => {
      card.classList.toggle("is-selected", this.isCardSelected(card));
      this.updateCardUi(card);
    });
  }

  onChange(event) {
  const checkbox = event.target.closest("[data-upsell-product-checkbox]");
  if (!checkbox || !this.contains(checkbox)) return;

  this.syncAllCardsUi();
}

  onClick(event) {
    const pill = event.target.closest("[data-option-value]");
    if (!pill || !this.contains(pill)) return;
    if (pill.disabled) return;

    const card = pill.closest("[data-upsell-card]");
    if (!card || !this.isCardSelected(card)) return;

    const group = pill.closest("[data-option-index]");
    if (!group) return;

    const idx = Number(group.dataset.optionIndex);
    const value = pill.dataset.optionValue || "";
    const state = card.__upsellState;

    if (state.selected[idx] === value) return;

    state.selected[idx] = value;
    this.autofillMissingOptions(card);
    this.refreshCardFromSelection(card);
  }

  autofillMissingOptions(card) {
    const state = card.__upsellState;
    const map = card.querySelector("[data-upsell-variant-map]");
    if (!map) return;

    const options = Array.from(map.options).filter((option) => {
      if (!option.value) return false;
      return this.matchesPartialSelection(option, state.selected);
    });

    const candidate = options.find((option) => option.dataset.available === "true") || options[0];
    if (!candidate) return;

    if (!state.selected[0] && candidate.dataset.option1) state.selected[0] = candidate.dataset.option1;
    if (!state.selected[1] && candidate.dataset.option2) state.selected[1] = candidate.dataset.option2;
    if (!state.selected[2] && candidate.dataset.option3) state.selected[2] = candidate.dataset.option3;
  }

  matchesPartialSelection(option, selected) {
    return [1, 2, 3].every((n, index) => {
      const selectedValue = selected[index];
      if (!selectedValue) return true;
      return (option.dataset[`option${n}`] || "") === selectedValue;
    });
  }

  hasCompleteSelection(card) {
    const groups = card.querySelectorAll("[data-option-index]");
    const state = card.__upsellState;

    return Array.from(groups).every((group) => {
      const idx = Number(group.dataset.optionIndex);
      return !!state.selected[idx];
    });
  }

  refreshCardFromSelection(card) {
    const state = card.__upsellState;
    const map = card.querySelector("[data-upsell-variant-map]");
    const variantIdInput = card.querySelector("[data-upsell-variant-id]");
    const priceEl = card.querySelector("[data-upsell-price]");
    const helpEl = card.querySelector("[data-upsell-help]");
    const options = Array.from(map?.options || []).filter((option) => option.value);

    const exact = options.find((option) => {
      return [1, 2, 3].every((n, index) => {
        const current = state.selected[index];
        if (!current) return true;
        return (option.dataset[`option${n}`] || "") === current;
      });
    });

    if (exact && exact.value && exact.dataset.available === "true" && this.hasCompleteSelection(card)) {
      if (variantIdInput) variantIdInput.value = exact.value;
      if (map) map.value = exact.value;
      if (priceEl) {
        this.setPriceDisplay(
          priceEl,
          exact.dataset.price || "",
          exact.dataset.comparePrice || ""
        );
      }
      if (helpEl) helpEl.textContent = "";
    } else {
      if (variantIdInput) variantIdInput.value = "";
      if (map) map.value = "";
      if (priceEl) this.setPriceDisplay(priceEl, "Select options", "");
      if (helpEl) {
        helpEl.textContent = this.hasCompleteSelection(card)
          ? "This combination is unavailable."
          : "Please select all required options.";
      }
    }

    this.updateCardUi(card);
  }

  updateCardUi(card) {
    const state = card.__upsellState;
    const groups = card.querySelectorAll("[data-option-index]");
    const map = card.querySelector("[data-upsell-variant-map]");
    const options = Array.from(map?.options || []).filter((option) => option.value);

    groups.forEach((group) => {
      const idx = Number(group.dataset.optionIndex);
      const selectedLabel = group.querySelector("[data-selected-label]");
      const pills = Array.from(group.querySelectorAll("[data-option-value]"));

      if (selectedLabel) selectedLabel.textContent = state.selected[idx] || "";

      pills.forEach((pill) => {
        const value = pill.dataset.optionValue || "";
        const active = state.selected[idx] === value;

        pill.setAttribute("aria-pressed", active ? "true" : "false");
        pill.classList.toggle("is-active", active);

        const possible = options.some((option) => {
          const probe = [...state.selected];
          probe[idx] = value;
          return this.matchesPartialSelection(option, probe) && option.dataset.available === "true";
        });

        pill.disabled = !possible;
      });
    });
  }

  getEligibleUpsellItems() {
    return this.cards
      .filter((card) => this.isCardSelected(card))
      .map((card) => {
        const variantId = String(card.querySelector("[data-upsell-variant-id]")?.value || "").trim();

        if (!variantId) return null;

        return {
          id: Number(variantId),
          quantity: 1
        };
      })
      .filter(Boolean);
  }

  async onSubmit(event) {
    const form = event.target;
    if (form !== this.mainForm) return;
    if (!form.matches("[data-upsell-aware='true']")) return;

    const idInput = form.querySelector('input[name="id"]');
    if (!idInput?.value) return;

    const upsellItems = this.getEligibleUpsellItems();
    if (!upsellItems.length) return;

    event.preventDefault();
    event.stopPropagation();

    const quantityInput = form.querySelector('input[name="quantity"]');
    const mainQty = quantityInput ? parseInt(quantityInput.value, 10) || 1 : 1;
    const mainVariantId = Number(idInput.value);

    const submitButtons = Array.from(form.querySelectorAll('[type="submit"]'));
    submitButtons.forEach((button) => button.setAttribute("aria-busy", "true"));

    document.documentElement.dispatchEvent(
      new CustomEvent("theme:loading:start", { bubbles: true })
    );

    try {
      await this.addBundleWithThemeEvents(
        form,
        { id: mainVariantId, quantity: mainQty },
        upsellItems
      );
    } finally {
      submitButtons.forEach((button) => button.removeAttribute("aria-busy"));
      document.documentElement.dispatchEvent(
        new CustomEvent("theme:loading:end", { bubbles: true })
      );
    }
  }

  async addBundleWithThemeEvents(mainForm, mainItem, upsellItems) {
    const sectionsToBundle = new Set();

    document.documentElement.dispatchEvent(
      new CustomEvent("cart:prepare-bundled-sections", {
        bubbles: true,
        detail: { sections: sectionsToBundle }
      })
    );

    const payload = {
      items: [mainItem, ...upsellItems],
      sections: Array.from(sectionsToBundle).join(",")
    };

    const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "X-Requested-With": "XMLHttpRequest"
      },
      body: JSON.stringify(payload)
    });

    const responseJson = await response.json();

    if (!response.ok) {
      mainForm.dispatchEvent(
        new CustomEvent("cart:error", {
          bubbles: true,
          detail: { error: responseJson.message }
        })
      );

      document.dispatchEvent(
        new CustomEvent("toast:show", {
          detail: {
            message: responseJson.message,
            tone: "error"
          }
        })
      );

      document.documentElement.dispatchEvent(
        new CustomEvent("cart:refresh", { bubbles: true })
      );

      return;
    }

    if (
      window.themeVariables?.settings?.cartType === "page" ||
      window.themeVariables?.settings?.pageType === "cart"
    ) {
      window.location.href = `${Shopify.routes.root}cart`;
      return;
    }

    const cartContent = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
    cartContent.sections = responseJson.sections;

    const items = responseJson.hasOwnProperty("items") ? responseJson.items : [responseJson];

    mainForm.dispatchEvent(
      new CustomEvent("variant:add", {
        bubbles: true,
        detail: { items, cart: cartContent }
      })
    );

    document.documentElement.dispatchEvent(
      new CustomEvent("cart:change", {
        bubbles: true,
        detail: {
          baseEvent: "variant:add",
          cart: cartContent
        }
      })
    );

    if (window.themeVariables?.settings?.cartType === "message") {
      document.dispatchEvent(
        new CustomEvent("toast:show", {
          detail: {
            message: window.themeVariables.strings.addedToCart.replace("{{product_title}}", items?.[0]?.title || "")
          }
        })
      );
    }
  }
}

if (!window.customElements.get("upsell-checkbox-bundle")) {
  window.customElements.define("upsell-checkbox-bundle", UpsellCheckboxBundle);
}
